'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var findit = require('domfs-findit');
var Emitify = require('emitify/legacy');
var itchy = require('itchy/legacy');
var inherits = require('inherits');

module.exports = Philip;

inherits(Philip, Emitify);

function Philip(entries, processingFn) {
    var _this = this;

    if (!(this instanceof Philip)) return new Philip(entries, processingFn);

    if (typeof processingFn !== 'function') throw Error('processingFn should be function!');

    Emitify.call(this);

    var array = Array.isArray(entries) ? entries : [entries];

    this._i = 0;
    this._n = 0;
    this._processingFn = processingFn;
    this._pause = false;
    this._prev = 0;

    this._find(array, function (files, dirs) {
        _this._files = files;
        _this._dirs = dirs;
        _this._n = files.length + dirs.length;
        _this._data = {};

        _this._getFiles(files, _this._data, function () {
            _this._process();
        });
    });
}

Philip.prototype._process = function () {
    var _this2 = this;

    var argsLength = this._processingFn.length;
    var fn = function fn(error) {
        ++_this2._i;

        if (error) {
            _this2.emit('error', error);
            _this2.pause();
        }

        _this2._process();
        _this2._progress();
    };

    var data = void 0;
    var name = this._dirs.shift();
    var type = 'directory';

    if (!name) {
        type = 'file';
        var el = this._files.shift();

        if (el) {
            name = el.fullPath;
            data = this._data[name];
        }
    }

    if (!name) return this.emit('end');

    var args = void 0;
    if (!this._pause) {
        switch (argsLength) {
            default:
                args = [type, name, data];
                break;

            case 6:
                args = [type, name, data, this._i, this._n];
                break;
        }

        args.push(fn);

        this._processingFn.apply(this, _toConsumableArray(args));
    }
};

Philip.prototype.pause = function () {
    this._pause = true;
};

Philip.prototype.continue = function () {
    if (this._pause) {
        this._pause = false;
        this._process();
    }
};

Philip.prototype.abort = function () {
    this._files = [];
    this._dirs = [];

    this._process();
};

Philip.prototype._progress = function () {
    var value = Math.round(this._i * 100 / this._n);

    if (value !== this._prev) {
        this._prev = value;
        this.emit('progress', value);
    }
};

Philip.prototype._getFiles = function (files, obj, callback) {
    var _this3 = this;

    var filesList = files.slice();
    var current = filesList.shift();

    if (!current) return callback(null, obj);

    current.file(function (file) {
        var name = current.fullPath;

        obj[name] = file;

        _this3._getFiles(filesList, obj, callback);
    });
};

Philip.prototype._find = function (entries, fn) {
    var files = [];
    var dirs = [];

    itchy(entries, function (entry, callback) {
        var finder = findit(entry);

        finder.on('directory', function (name) {
            dirs.push(name);
        });

        finder.on('file', function (name, current) {
            files.push(current);
        });

        finder.on('end', function () {
            callback();
        });
    }, function () {
        fn(files, dirs);
    });
};